import React, { Component } from 'react';
import { connect } from 'react-redux';
import cs from 'classnames';

import { options } from '~/pages/MembershipPlans/utils';
import mapDispatch from '~/misc/mapDispatch';
import { setSelectPlan } from '~/modules/payment/actions';
import css from './style.css';

const showBillingText = {
  monthly: 'month',
  annually: 'year',
};
class BillingOptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPlan: {},
      expandContent: '',
    };
    this.renderHeader = this.renderHeader.bind(this);
  }
  componentDidMount() {
    // default selected
    const { billings, accountBillingCycle, changeSelectPlan, account } = this.props;
    let showCount = 0;
    let selectedPlan = null;
    billings.forEach(item => {
      if (item.showCurrent) {
        showCount++;
        if (!selectedPlan) {
          selectedPlan = item[accountBillingCycle];
        }
      }
    });
    if (account.accountLevel <= 1) {
      selectedPlan = billings[1]['annually'];
    }
    if (account.accountLevel >= 4) {
      selectedPlan = billings[2]['annually'];
    }
    this.setState({ showCount, selectedPlan });
    changeSelectPlan({ selectedPlan });
  }
  selectPlan(item) {
    const { changeSelectPlan } = this.props;
    this.setState({ selectedPlan: item });
    changeSelectPlan({ selectedPlan: item });
  }
  expandOptionContent(item) {
    const newExpandContent = this.state.expandContent === item ? '' : item;
    this.setState({ expandContent: newExpandContent });
  }
  renderHeader() {
    const { showCount, selectedPlan } = this.state;
    const { billings, accountBillingCycle, account } = this.props;
    const { premiumInfo } = this.props.user;
    if (premiumInfo && account.accountLevel >= 4) {
      const showItem = billings[2];
      return showItem ? (
        <header>
          <div className={css.empty}></div>
          <div
            className={cs(css.billingPlan, {
              [css.billingPlanSelected]: showItem['annually'].key === selectedPlan.key,
            })}
            onClick={() => this.selectPlan(showItem['annually'])}>
            <div className={css.billingTag}>{showItem.priceTag}</div>
            <div className={css.billingTitle}>{showItem['annually'].grade_name}</div>
            <div className={css.billingFeatures}>{showItem.featuresText}</div>
            <div className={cs(css.billingPrice, css.billingPriceAnnually)}>
              ${showItem['annually'].discount_price / 100}
              <span>/{showBillingText['annually']}</span>
            </div>
            <div className={css.billingRecommended}>{'2 months free'}</div>
            <div className={css.selectedRight}></div>
          </div>
        </header>
      ) : null;
    }
    const fullHeader = (
      <header>
        <div className={css.empty}></div>
        {billings.map((item, index) => {
          return (
            <div className={css.billingFullPlan} key={index}>
              {item.priceTag && <div className={css.billingTag}>{item.priceTag}</div>}
              <div className={css.billingTitle}>{item['monthly'].grade_name}</div>
              {item.featuresText && <div className={css.billingFeatures}>{item.featuresText}</div>}
              <div
                className={cs(css.billingPrice, {
                  [css.billingPriceSelected]: item['annually'].key === selectedPlan.key,
                })}
                onClick={() => this.selectPlan(item.annually)}>
                <p className={css.priceLine}>
                  ${item['annually'].discount_price / 100}
                  <span> /year</span>
                </p>
                <span className={css.priceDesc}>2 months Free</span>
                <div className={css.selectedRight}></div>
              </div>
              <div
                className={cs(css.billingPrice, {
                  [css.billingPriceSelected]: item['monthly'].key === selectedPlan.key,
                })}
                onClick={() => this.selectPlan(item.monthly)}>
                <p className={css.priceLine}>
                  ${item['monthly'].discount_price / 100}
                  <span> /month</span>
                </p>
                <div className={css.selectedRight}></div>
              </div>
            </div>
          );
        })}
      </header>
    );
    const partHeader = (
      <header>
        <div className={css.empty}></div>
        {billings.map((item, index) => {
          return item.showCurrent ? (
            <div
              className={cs(css.billingPlan, {
                [css.billingPlanSelected]: item[accountBillingCycle].key === selectedPlan.key,
              })}
              key={index}
              onClick={() => this.selectPlan(item[accountBillingCycle])}>
              <div className={css.billingTag}>{item.priceTag}</div>
              <div className={css.billingTitle}>{item[accountBillingCycle].grade_name}</div>
              <div className={css.billingFeatures}>{item.featuresText}</div>
              <div
                className={cs(css.billingPrice, {
                  [css.accountBillingCycle]: accountBillingCycle === 'annually',
                })}>
                ${item[accountBillingCycle].discount_price / 100}
                <span>/{showBillingText[accountBillingCycle]}</span>
              </div>
              <div className={css.billingRecommended}>
                {accountBillingCycle === 'monthly' ? '' : '2 months free'}
              </div>
              <div className={css.selectedRight}></div>
            </div>
          ) : null;
        })}
      </header>
    );
    return showCount === 3 ? fullHeader : partHeader;
  }
  render() {
    const { showCount, expandContent } = this.state;
    const { billings } = this.props;
    return (
      <section className={cs(css.billingOptions, { [css.billingOptionsSmall]: showCount <= 1 })}>
        {this.renderHeader()}
        <main>
          {options.map(item => (
            <div className={css.rows} key={item.name}>
              <div className={css.title}>
                <span>{item.name}</span>
                <img
                  src='/assets/exclamation-cricle.png'
                  onClick={() => this.expandOptionContent(item.name)}
                />
                {expandContent === item.name && (
                  <div className={css.hideContent}>{item.expandContent}</div>
                )}
              </div>
              {billings[0].showCurrent && (
                <div className={css.content}>
                  {item.essential && (
                    <img className={css.rightSymbol} src='/assets/rightGreenNew.svg' />
                  )}
                </div>
              )}
              {billings[1].showCurrent && (
                <div className={css.content}>
                  {item.preferred && (
                    <img className={css.rightSymbol} src='/assets/rightGreenNew.svg' />
                  )}
                </div>
              )}
              {billings[2].showCurrent && (
                <div className={css.content}>
                  {item.ultimate && (
                    <img className={css.rightSymbol} src='/assets/rightGreenNew.svg' />
                  )}
                </div>
              )}
            </div>
          ))}
        </main>
      </section>
    );
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    changeSelectPlan: ({ selectedPlan }) => {
      dispatch({
        type: 'SELECTED_PAYMENT_PLAN',
        payload: selectedPlan,
      });
    },
  };
};
export default connect(
  ({ user, account }) => ({ user, account }),
  mapDispatchToProps
)(BillingOptions);



// WEBPACK FOOTER //
// ./src/pages/MembershipPlans/components/PaymentOptions/index.js